// Category Modal Component
// Modal for creating and editing tutorial video categories

import React, { useState, useEffect } from 'react';
import { RevoltModal } from '../../../../components/RevoltModal';
import { RevoltInput } from '../../../../components/RevoltInput';
import { RevoltButton } from '../../../../components/RevoltButton';
import './CategoryModal.css';

export function CategoryModal({
  isOpen,
  onClose,
  mode = 'create', // 'create' or 'edit'
  initialData = {},
  onSubmit
}) {
  // Form state
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reset form when modal opens/closes or mode/data changes
  useEffect(() => {
    if (isOpen) {
      if (mode === 'edit' && initialData) {
        setName(initialData.name || '');
      } else {
        // Create mode - reset to empty
        setName('');
      }
      setIsSubmitting(false);
    }
  }, [isOpen, mode, initialData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const categoryData = {
        name: name.trim(),
        ...(mode === 'edit' && initialData?.id && { id: initialData.id })
      };

      // Call the onSubmit callback with the data
      if (onSubmit) {
        await onSubmit(categoryData);
      }

      onClose();
    } catch (error) {
      console.error('Error saving category:', error);
      // Could add error handling UI here
    } finally {
      setIsSubmitting(false);
    }
  };

  const modalTitle = mode === 'create' ? 'Create Category' : 'Edit Category';
  const submitButtonText = mode === 'create' ? 'Create Category' : 'Save Changes';

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title={modalTitle}
    >
      <form onSubmit={handleSubmit} className="category-modal-form">
        {/* Name Field */}
        <div className="form-group">
          <label htmlFor="category-name" className="form-label">
            Category Name <span className="required">*</span>
          </label>
          <RevoltInput
            id="category-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter category name..."
            required
            maxLength={50}
          />
          <div className="form-help">
            Choose a descriptive name for this category (e.g., "Getting Started", "Advanced Features").
          </div>
        </div>

        {/* Modal Actions */}
        <div className="modal-actions">
          <RevoltButton
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            type="submit"
            variant="primary"
            disabled={!name.trim() || isSubmitting}
          >
            {isSubmitting ? (
              <>
                <i className="fa-solid fa-spinner fa-spin"></i>
                {mode === 'create' ? 'Creating...' : 'Saving...'}
              </>
            ) : (
              submitButtonText
            )}
          </RevoltButton>
        </div>
      </form>
    </RevoltModal>
  );
}